import React from 'react';
import IconName from "../../../svgLogo/SvgLogo";

const MyCommentBox = () => {
    return (
        <div className="my-comment-box-wrapper xmt-14">
            <div className="title-comment d-flex align-items-center xmb-4 xmb-lg-10">
                <div className="img">
                    <img src="./assets/sample-image/1420-w320h320.png" alt="img" className="img-fluid"/>
                </div>
                <div className="text">
                    <h2 className="title">گوشی شیائومی می نوت ۹ پرو دوسیم کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ رم</h2>
                    <div className="info-product d-flex align-items-center">
                        <div className="color-product"><span className="color"
                                                             style={{background: "#000000"}}></span><span className="d-none d-lg-block"> مشکی</span>
                        </div>
                        <div className="seller-name xmr-2 xmr-lg-10"><IconName name="vendor"
                                                                               className="icon xml-2"/> کامپیوتر زرد
                            آذربایجان
                        </div>
                    </div>
                </div>
            </div>
            <div className="info-comment-responsive d-block d-lg-none">
                <h3 className="comment-title">بهترین خرید امسال من</h3>
                <div className="comment-time persian-number">حدود 2 ساعت پیش</div>
                <div className="comment-status ok-product xmt-3"><IconName name="thumb_up" className="icon"/> خریدارم،
                        توصیه می‌کنم
                    </div>
                <div className="star-rating xmt-3" star-score={5}>
                    <IconName name="star" className="icon"/>
                    <IconName name="star" className="icon"/>
                    <IconName name="star" className="icon"/>
                    <IconName name="star" className="icon"/>
                    <IconName name="star" className="icon"/>
                </div>
            </div>
            <div className="comment-text xpy-4 xpx-6 xmt-4 xmt-lg-0">
                <h3 className="title d-none d-lg-block">بهترین خرید امسال من</h3>
                <p className="text">من الان سه ماهه سامسونگ داشتم عوض کردم اینو خریدم یعنی تا امروز هرروز یدونه امکانات
                    جدیدشو میبینم و کیفیت و سرعتش حرف نداره … گیم بوتر داره که رم رو از هر لحاظ به نحو صحیح عمل میکنه ـ.
                    کیفیت گرافیکی عالی … دوربیناش فوق العاده خوب … لمس و تاچ و نرم افزاری که حرف نداره … هر هفته هم یه
                    نوع آپدیت میاد برات که بروز میکنه و امکانات اضافه میشه یعنی انگا داری هر هفته یه گوشی مدل بالاشو
                    میخری</p>
            </div>
            <div className="points-comment xmt-6">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="good-points">
                            <div className="title xmb-4"><span>نقاط قوت</span></div>
                            <div className="list-points">
                                <ul className="list-unstyled">
                                    <li><span>نمایشگر بزرگ 12.9 اینچی باکیفیت خیره‌کننده</span>
                                    </li>
                                    <li><span>مجهز به چهار اسپیکر باکیفیت</span></li>
                                    <li><span>پردازنده‌ی بسیار قدرتمند</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 xmt-4 xmt-lg-0">
                        <div className="bad-points">
                            <div className="title xmb-4"><span>نقاط ضعف</span></div>
                            <div className="list-points">
                                <ul className="list-unstyled">
                                    <li><span>عدم تعادل مناسب دستگاه در هنگام تایپ با کیبورد فیزیکی</span>
                                    </li>
                                    <li><span>قیمت زیاد</span></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="info-comment d-flex justify-content-between align-items-center xmt-4 xpx-2 d-none d-lg-flex">
                <div className="comment-score d-flex align-items-center">
                    <span className="comment-time persian-number">حدود 2 ساعت پیش</span>
                    <span className="comment-status ok-product xmr-3"><IconName name="thumb_up" className="icon"/> خریدارم،
                        توصیه می‌کنم
                    </span>
                    <div className="star-rating xmr-5" star-score={5}>
                        <IconName name="star" className="icon"/>
                        <IconName name="star" className="icon"/>
                        <IconName name="star" className="icon"/>
                        <IconName name="star" className="icon"/>
                        <IconName name="star" className="icon"/>
                    </div>
                </div>
                <div className="edit-comment d-flex align-items-center">
                    <div className="edit xml-2">ویرایش</div>
                    <div className="delete">حذف</div>
                </div>
            </div>
            <div className="edit-button-responsive xmt-6 text-center d-flex d-lg-none">
                <div className="button d-flex justify-content-center align-items-center"><span className="text">ویرایش</span></div>
            </div>
        </div>
    );
};

export default MyCommentBox;
